import { render, staticRenderFns } from "./GoToPayment.vue?vue&type=template&id=8db0753e&scoped=true"
import script from "./GoToPayment.vue?vue&type=script&lang=ts"
export * from "./GoToPayment.vue?vue&type=script&lang=ts"
import style0 from "./GoToPayment.vue?vue&type=style&index=0&id=8db0753e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db0753e",
  null
  
)

export default component.exports